import React, { useEffect, useState, useCallback, useMemo } from 'react';
import ReactDom from 'react-dom';
import { Link, useHistory, useParams } from 'react-router-dom';
import clsx from 'clsx';
import { useForm } from 'react-hook-form';
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Container,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
} from 'reactstrap';
import {
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Table,
} from 'reactstrap';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import Select from 'react-select';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ParticipantForm, {
  LegalParticipantSchema,
  IndividualParticipantSchema,
  ParticipantSchema,
} from './ParticipantForm';
import {
  createContract,
  saveContract,
  sendContract,
} from '../api/actions/contracts';
import { updateTemplate } from '../api/actions/templates';
import { fetcher } from '../api/client';
import { faEdit, faUser } from '@fortawesome/free-regular-svg-icons';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import LoadingButton from './LoadingButton';
import ConfirmationModal from './ConfirmationModal';
import NoContractsModal from './NoContractsModal';
import { PDFIndex } from '../pages/PdfViewer';
import { useTranslation } from 'react-i18next';
import { useProfile } from '../api/hooks/profile';
import { unmaskPhone, truncate } from '../utils';
import { toast } from 'react-toastify';
import Checkbox from './Checkbox';
import { languages } from '../config';
import i18n from '../i18n';
import CustomTextEditor from './Editor/Editor';
import { mongoObjectId } from '../utils';
import { useStripe } from '@stripe/react-stripe-js';
import config from '../config';
import { getDisplayName } from '../utils';
import InputWithLoader from './InputWithLoader';
import { useAuthState } from '../context/auth';
import FileSendIcon from '../images/pdf/file-send.svg';

import createPersistedState from 'use-persisted-state';

import {
  useEditor,
  useEditorActions,
  FILL_MY_DATA,
  RESET_FILL_MY_DATA,
  SET_LANGUAGE,
  SET_SHIELD_TYPE,
  RESET_DOCUMENT,
  SET_PARTICIPANTS,
  SET_NUM_PAGES,
  SET_CURRENT_PAGE,
  SET_DOCUMENT,
  CHANGED_DATA,
  RESTORE_ITEM,
  SET_LAWYER_NEEDED,
  ADD_TO_CART,
  SET_IS_INVOICE_NEEDED,
  SET_CHECKOUT_INFO,
} from '../context/editor';

import { useUserLanguage } from '../hooks/useLanguages';

const useAccountVerificationState = createPersistedState('accountVerified');

// const ContractSchema = Yup.object().shape({
//     language: Yup.string(),
//     shield: Yup.string(),
//     fillMyData: Yup.string(),
//     participants: Yup.array().of(ParticipantSchema)
//   })

//const createTemplate = ({templateId, ...values}) => {

const createTemplate = ({ templateId, document, tenantId }) => {
  let url = `/templates/${templateId}/buy`;

  return {
    method: 'POST',
    endpoint: url,
    prefix: ' ',
    headers: {
      'Content-Type': 'application/json',
    },
    body: { ...document, tenantId },
  };
};

const buttoner = {
  borderRadius: '50%',
  color: '#6F767D',
  backgroundColor: 'white',
  font: 'normal normal normal 10px/14px Lato',
  border: '1px solid #D5D5D5',
  display: 'inline-block',
  lineHeight: '30px',
  marginRight: '7px',
  marginBottom: '7px',
  textAlign: 'center',
  width: '30px',
};

const buttonerActive = {
  borderRadius: '50%',
  color: '#FFFFFF',
  backgroundColor: '#F47B33',
  font: 'normal normal normal 10px/14px Lato',
  border: '1px solid #F47B33',
  display: 'inline-block',
  lineHeight: '30px',
  marginRight: '7px',
  marginBottom: '7px',
  textAlign: 'center',
  width: '30px',
};

const myBtn = {
  position: 'relative',
  display: 'inline-block',
};

const faCheck = {
  position: 'absolute',
  top: '0px',
  right: '7px',
  borderRadius: '50%',
  color: 'white',
  backgroundColor: '#07BF39',
  font: 'normal normal normal 8px/11px Lato',
  border: '1px solid #07BF39',
  display: 'inline-block',
  textAlign: 'center',
  width: '10px',
  height: '10px',
};

const pFont = {
  font: 'normal normal bold 16px/20px Lato',
};

const AccountVerifyModal = (props) => {
  const { isOpen } = props;
  const { t } = useTranslation('common');
  return (
    <Modal isOpen={isOpen} centered>
      <ModalHeader className="text-center">
        {t('successMessages.verifyAccount')}
      </ModalHeader>
      <ModalBody className="text-center">
        <span className="text-center text-muted mb-4 text-center">
          {t('successMessages.verifyAccountLink')}
        </span>
        <img
          className="m-1 mb-2 p-1"
          src={FileSendIcon}
          style={{ width: 120 }}
        />
        <br />
        <span className="font-italic text-center text-muted mb-4 text-center">
          {t('successMessages.waitingVerifyAccount')}
        </span>
      </ModalBody>
    </Modal>
  );
};

function ContractConfiguration({
  className,
  onClose,
  formik: {
    handleChange,
    handleSubmit,
    isSubmitting: isSending,
    values,
    errors,
    touched,
  },
  onFillMyData,
  fillMyData,
  saving,
  documentId,
  tabs,
  currentTab,
  header,
  footer,
  FooterComponent,
  onRequestAgreement,
  languages,
  currentLanguage,
  onLanguageChange,
  shields,
  onShieldChange,
  shieldType,
  isPdf,
  isDynamic,
  onAddParticipant,
  numPagesArr,
  pdfUrl,
  onPDFPageClick,
  goToPage,
  isEditable,
  onDocumentLoadSuccess,
  onRemoveParticipant,
  onAddParticipantSignature,
  isOpen,
  setIsOpen,
  submitInterceptor,
}) {
  const { t } = useTranslation('common');
  const [truncated, setTruncated] = useState(true);

  // const {name, ...participantErrors} = errors;
  // const {name, ...participantTouched} = touched;
  // const contractErrors = {
  //     name
  // }
  // if (!isOpen || !contract) {
  //     return null;
  // }

  const [innerCurrentTab, setInnerCurrentTab] = useState(currentTab);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [buttonLegend, setButtonLegend] = useState();

  const [editorState, editorDispatch] = useEditor();
  const [currentEditableItem, setCurrentEditableItem] = useState(false);
  const [isCheckout, setCheckout] = useState(1);
  const [isMoral, setIsMoral] = useState(false);
  const { register, watch, errors: errorRQ } = useForm({ mode: 'onBlur' });
  const { setCurrentElement } = useEditorActions();
  const [stripePaymentId, setStripePaymentId] = useState();
  const { profile, can } = useProfile();
  const stripe = useStripe();
  const auth = useAuthState();
  const { publicTemplateId, templateId } = useParams();
  const editionPrice = can('EDIT_TEMPLATE') ? 0 : 25;

  const handlePurchase = async (result) => {
    let itemsT = [];
    let newDocumentId = publicTemplateId ? 'public-template' : 'template';

    if (
      !can('EDIT_TEMPLATE') &&
      editorState?.carrito.filter((x) => x._id !== -1).length > 0
    )
      itemsT.push({
        price: 'edit_element_mx',
        quantity: editorState?.carrito.filter((x) => x._id !== -1).length,
      });
    if (editorState?.carrito.filter((x) => x._id === -1).length > 0)
      itemsT.push({
        price: 'lawyer_approval_mx',
        quantity: editorState?.carrito.filter((x) => x._id === -1).length,
      });
    if (
      editorState?.mode === 'public-template' &&
      editorState?.publicTemplate?.stripeId &&
      editorState?.publicTemplate?.stripeInfo?.id &&
      !editorState?.publicTemplate?.userTemplate?._id
    )
      itemsT.push({
        price: editorState?.publicTemplate?.stripeInfo?.id,
        quantity: 1,
      });

    await stripe.redirectToCheckout({
      successUrl: `${config.baseUrl}/checkout/success?productName=Edicion De Plantilla`,
      //cancelUrl: `${config.baseUrl}/documents/${editorState?.documentId}/edit`,
      cancelUrl: `${config.baseUrl}/${newDocumentId}s/${editorState.documentId}/edit`,

      mode: 'payment',
      lineItems: [...itemsT],
      clientReferenceId: `template-${result}`,
      customerEmail: profile.email,
    });
  };

  const { mutate: mutateRecover } = useMutation(
    (payload) => fetcher(createTemplate(payload)),
    {
      onSuccess: (result) => {
        handlePurchase(result.templateId);
      },
    }
  );

  const { mutate: saveTemplateMutate } = useMutation(
    (payload) => fetcher(updateTemplate(payload)),
    {
      onSuccess: (result) => {
        toast.success('Se ha guardado con exito');
      },
    }
  );

  const changeTab = (tabId) => () => {
    setInnerCurrentTab(tabId);
  };

  const unTruncate = () => {
    setTruncated((isTruncated) => !isTruncated);
  };

  const editMode = () => {
    setCurrentEditableItem(true);
  };

  const cancelEdit = () => {
    setCurrentEditableItem(false);
  };

  const selectNewItem = (id) => {
    setCurrentElement(id);
    setCurrentEditableItem(false);
  };

  useEffect(() => {
    setInnerCurrentTab(currentTab);
  }, [currentTab]);

  const toggleIsInvoice = () => {
    editorDispatch({
      type: SET_IS_INVOICE_NEEDED,
      data: { isInvoiceNeeded: !editorState?.checkoutInfo?.isInvoiceNeeded },
    });
  };

  const toggleIsLawyer = () => {
    if (!editorState?.checkoutInfo?.isLawyerNeeded) {
      editorDispatch({
        type: ADD_TO_CART,
        data: {
          producto: 'Revisión de abogado',
          importe: 250,
          _id: -1,
          index: -1,
        },
      });
    } else if (editorState?.checkoutInfo?.isLawyerNeeded) {
      deleteItem(-1, -1);
    }
    editorDispatch({
      type: SET_LAWYER_NEEDED,
      data: { isLawyerNeeded: !editorState?.checkoutInfo?.isLawyerNeeded },
    });
  };

  const deleteItem = (id, index) => {
    setCurrentEditableItem(false);
    toast.error(t('templateEdition.deleteModal'), {
      position: 'top-right',
    });
    setCurrentElement({});
    editorDispatch({ type: RESTORE_ITEM, data: { id, index } });
  };

  const handleCheckout = () => {
    if (currentEditableItem)
      toast.error(t('templateEdition.noSavedChanges'), {
        position: 'top-right',
      });
    else {
      setCheckout(2);
      setCurrentEditableItem(false);
      setCurrentElement({});
    }
  };

  const handleSaveTemplate = () => {
    saveTemplateMutate({
      templateId: editorState.document._id || editorState.document.templateId,
      elements: editorState.document.elements,
    });
  };

  const onSignUpSuccess = () => {
    setIsOpen(true);
  };

  const handleConfirm = () => {
    if (!auth.hasAccount)
      auth.openAuthModal({ type: 'signup', onSignUpSuccess });
    else setIsConfirmationOpen(true);
  };

  const Question = ({ question, participants, setButtonLegend }) => {
    const participantsAreVoid = Object.values(participants).every(
      (i) => i.name === ''
    );

    participantsAreVoid
      ? setButtonLegend('Pagar')
      : setButtonLegend('Pagar y enviar');

    const Text = ({ children }) => (
      <span className="text-accent">{children}</span>
    );
    return (
      <span className="px-2">
        {question}
        <br></br>
        {participantsAreVoid ? (
          <> {t('actions.sendWithouthParticipants')} </>
        ) : (
          <>
            <span>{t('actions.sendWithParticipants')} </span>
            <br></br>
            {participants.map((participant, i) => (
              <React.Fragment key={participant._id}>
                {i === participants.length - 1 &&
                  participants.length > 1 &&
                  participant.name !== '' &&
                  ` ${t('and')} `}
                {i === 0 && ''}
                {i > 0 &&
                  i < participants.length - 1 &&
                  participant.name !== '' &&
                  ',  '}
                <Text key={participant._id}>
                  {participant.obligation === 'individual'
                    ? getDisplayName(participant.name, participant.last_name)
                    : getDisplayName(participant.name)}
                </Text>
              </React.Fragment>
            ))}
          </>
        )}
        <br />
        <br />
        <span style={{ font: 'normal normal normal 12px/12px Lato' }}>
          {t('actions.useTemplateMessage')}
        </span>
      </span>
    );
  };

  const handlePayment = () => {
    const email = watch('email');
    const rfc = watch('rfc');

    editorDispatch({
      type: SET_CHECKOUT_INFO,
      data: {
        isLawyerNeeded: editorState?.checkoutInfo?.isLawyerNeeded,
        invoiceRFC: rfc,
        invoiceEmail: email,
        isInvoiceNeeded: editorState?.checkoutInfo?.isInvoiceNeeded,
        isMoral: isMoral,
        paymentTotal: editorState?.carrito
          .map((x) => x?.importe)
          .reduce((acc, score) => acc + score, 0),
      },
    });

    if (!auth.hasAccount) {
      return auth.openAuthModal({ type: 'signup' });
    } else {
      mutateRecover({
        templateId: documentId,
        document: editorState?.document,
        tenantId: profile.organization,
      });
    }
  };

  //console.log(editorState);

  const handleChangeClauses =
    ({ value }) =>
    () => {
      let price = value[0].type === 'title' ? 0 : editionPrice;
      let textAlign;
      if (
        value[0].type === 'align_right' ||
        value[0].type === 'align_center' ||
        value[0].type === 'align_left' ||
        value[0].type === 'align_justify'
      ) {
        textAlign = value[0].type.replace('align_', '');
        editorDispatch({
          type: CHANGED_DATA,
          data: {
            children: value[0].children[0].children,
            _id: value[0].children[0]._id,
            isModified: true,
            type: value[0].children[0].type,
            price: price,
            textAlign: textAlign,
          },
        });
      } else
        editorDispatch({
          type: CHANGED_DATA,
          data: {
            children: value[0].children,
            _id: value[0]._id,
            isModified: true,
            type: value[0].type,
            price: price,
            textAlign: value[0].textAlign,
          },
        });
      setCurrentEditableItem(false);
      setCurrentElement({});
    };

  return (
    <Card className={`${className} bg-grey`}>
      {header && (
        <CardHeader tag={Container}>
          <Row>
            <Col md={8} xs={8}>
              <h5 className="mb-0 title font-weight-bold">
                {t('documentConfiguration')}
              </h5>
              <p className="text-muted mb-0" onClick={unTruncate}>
                {truncated ? truncate(values.name, 55) : values.name}
              </p>
            </Col>
            <Col md={4} xs={4}>
              <Button
                className="pointer float-right"
                id="closeConfig"
                color="primary"
                size="sm"
                onClick={onClose}
              >
                {t('actions.close')}
                <FontAwesomeIcon
                  icon={'times-circle'}
                  mask="far"
                  className="ml-2"
                  inverse
                />
              </Button>
            </Col>
          </Row>
        </CardHeader>
      )}
      <CardBody
        className={clsx('pb-0', 'p-0 h-100')}
        style={{ marginBottom: 40 }}
      >
        {tabs && (
          <Nav tabs>
            {/* {isPdf && (
                            <NavItem>
                                <NavLink className={clsx("py-2 px-5", innerCurrentTab === 1 && "active")} onClick={changeTab(1)} tag="strong">
                                    {t("index")}
                                </NavLink>
                            </NavItem>
                        )}
                        <NavItem>
                            <NavLink className={clsx("py-2 px-5", innerCurrentTab === 2 && "active")} onClick={changeTab(2)} tag="strong">
                                <FontAwesomeIcon className="mr-2" icon={faUser} />
                                {t("templateEdition.participants")}
                            </NavLink>
                        </NavItem> */}
            <NavItem>
              <NavLink
                className={clsx('py-2 px-5', innerCurrentTab === 3 && 'active')}
                onClick={changeTab(3)}
                tag="strong"
              >
                <FontAwesomeIcon className="mr-2" icon={faEdit} />
                {t('templateEdition.personalization')}
              </NavLink>
            </NavItem>
          </Nav>
        )}
        <TabContent
          activeTab={innerCurrentTab}
          className={clsx(
            'bg-light pb-2 border-right border-bottom border-left overflow-auto h-100',
            !isPdf && 'border-0'
          )}
        >
          {isPdf && (
            <TabPane
              tabId={1}
              className={clsx(
                'align-self-center justify-content-center overflow-auto h-100',
                innerCurrentTab === 1 && 'd-flex '
              )}
            >
              <PDFIndex
                url={pdfUrl}
                numPagesArr={numPagesArr}
                onItemClick={onPDFPageClick}
                goTo={goToPage}
                onDocumentLoadSuccess={onDocumentLoadSuccess}
              />
            </TabPane>
          )}
          <TabPane tabId={2}>
            <div
              className={clsx(
                'general-configuration px-4 h-100',
                isPdf && 'mt-2'
              )}
            >
              <label>{t('shield')}</label>
              <Select
                options={shields}
                value={shieldType}
                onChange={onShieldChange}
                isDisabled={!isEditable}
                styles={{ menu: (base) => ({ ...base, zIndex: 1000 }) }}
              />
              <label className="mt-2">{t('forms.language')}</label>
              <Select
                options={languages}
                value={currentLanguage}
                onChange={onLanguageChange}
                isDisabled={!isEditable}
                styles={{ menu: (base) => ({ ...base, zIndex: 1000 }) }}
              />
            </div>

            <div className="participants">
              {/* {   
                            isPdf && isEditable &&
                            <Button 
                                className="mx-3 mt-4" 
                                size="sm" 
                                color="accent"
                                onClick={onAddParticipant}
                                disabled={!isEditable}
                            >
                                Agregar participante
                            </Button>
                        } */}
              {values?.participants &&
                Object.values(values.participants).map((participant, i) => (
                  <div key={participant._id} className="d-flex flex-column">
                    {/* { i !== 0 && <div className="border-bottom"></div> } */}
                    <ParticipantForm
                      shieldType={shieldType}
                      loading={isSending}
                      isDynamic={isDynamic}
                      key={participant._id}
                      name={`participants.${participant._id}`}
                      onChange={handleChange}
                      onRequestAgreement={onRequestAgreement}
                      onFillMyData={onFillMyData}
                      showFillMyData={
                        (!fillMyData.length ||
                          fillMyData.includes(participant._id)) &&
                        auth.hasAccount
                      }
                      fillMyData={fillMyData}
                      participant={participant}
                      editable={isEditable}
                      errors={errors?.participants?.[participant._id]}
                      touched={errors?.participants?.[participant._id]}
                      onRemove={
                        isPdf || isDynamic ? onRemoveParticipant : undefined
                      }
                    />
                    {isEditable && isPdf && (
                      <Button
                        className="align-self-end mb-2 mr-2"
                        color="primary"
                        onClick={onAddParticipantSignature(participant._id)}
                      >
                        {t('actions.addSignature')}
                      </Button>
                    )}
                    <div className="border-bottom"></div>
                  </div>
                ))}
              {(isPdf || isDynamic) && isEditable && (
                <div
                  className="mx-3 my-4 color-accent pointer"
                  onClick={onAddParticipant}
                  disabled={!isEditable}
                >
                  + {t('actions.addParticipant')}
                </div>
              )}
            </div>
          </TabPane>
          <TabPane tabId={3}>
            {isCheckout === 1 && (
              <div
                className={clsx(
                  'general-configuration px-4 h-100 mt-5',
                  isPdf && 'mt-2'
                )}
              >
                <p
                  style={{
                    font: 'normal normal bold 20px/25px Lato',
                    textAlign: 'center',
                    color: '#F47B33',
                  }}
                >
                  {t('actions.templateEditElement')}
                </p>
                <p
                  style={{
                    font: 'normal normal normal 14px/18px Lato',
                    textAlign: 'center',
                    color: '#6F767D',
                  }}
                >
                  {t('actions.templateEditElementLegend')}
                </p>
                <br></br>
                <p style={pFont}>{t('actions.templateElements')}</p>
                <div className="pb-3">
                  {editorState?.document?.elements
                    ?.filter((el) => !['header', 'signature'].includes(el.type))
                    .map((x, index) => {
                      return x.type !== 'signature' ? (
                        <div
                          key={x._id}
                          style={myBtn}
                          onClick={() => {
                            selectNewItem(x);
                          }}
                        >
                          <span
                            style={
                              editorState?.currentElement?._id === x._id
                                ? buttonerActive
                                : buttoner
                            }
                          >
                            {index + 1}
                          </span>
                          {x?.isModified && <i style={faCheck}>✓</i>}
                        </div>
                      ) : (
                        ''
                      );
                    })}
                </div>

                {editorState?.currentElement?._id && (
                  <>
                    <CustomTextEditor
                      textAlign={
                        editorState?.currentElement?.textAlign || 'left'
                      }
                      contract={editorState.document}
                      key={editorState?.currentElement?._id}
                      children={[editorState?.currentElement]}
                      isReadOnly={true}
                    ></CustomTextEditor>
                    <div className="text-right">
                      <button
                        className="btn btn-accent-100 btn-sm text-light mt-2"
                        onClick={editMode}
                      >
                        Editar
                      </button>
                    </div>
                  </>
                )}

                <hr className="pb-3" />

                {currentEditableItem && (
                  <CustomTextEditor
                    textAlign={editorState?.currentElement?.textAlign || 'left'}
                    contract={editorState.document}
                    key={editorState?.currentElement?._id}
                    children={[editorState?.currentElement]}
                    isReadOnly={false}
                    onChangeClause={handleChangeClauses}
                    onCancelEdit={cancelEdit}
                  />
                )}
              </div>
            )}

            {isCheckout === 2 && (
              <div
                className={clsx(
                  'general-configuration px-4 h-100 mt-5',
                  isPdf && 'mt-2'
                )}
              >
                <h1
                  className="py-4"
                  style={{ font: 'normal normal bold 14px/18px Lato' }}
                >
                  {t('templateEdition.cart')}
                </h1>
                <Table bordered>
                  <thead
                    style={{
                      font: 'normal normal bold 11px/14px Lato',
                      background: '#FCFCFC',
                    }}
                  >
                    <tr>
                      <th>{t('templateEdition.products')}</th>
                      <th>{t('templateEdition.delete')}</th>
                      <th>{t('templateEdition.amount')}</th>
                    </tr>
                  </thead>
                  <tbody
                    style={{
                      font: 'normal normal normal 11px/14px Lato',
                      padding: '14px',
                      color: '#6F767D',
                    }}
                  >
                    {editorState?.carrito?.map((x) => (
                      <tr
                        key={x.index}
                        onMouseEnter={() => selectNewItem(x)}
                        onMouseLeave={() => selectNewItem('')}
                      >
                        <td>{x?.producto}</td>
                        <td onClick={() => deleteItem(x._id, x.index)}>
                          {' '}
                          <FontAwesomeIcon
                            color="#F47B33"
                            className="mr-2"
                            icon={faTimes}
                          />
                        </td>
                        <td>${x?.importe} MXN</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr style={{ font: 'normal normal bold 11px/14px Lato' }}>
                      <td>Total</td>
                      <td>
                        <i className="fa fa-times" aria-hidden="true"></i>
                      </td>
                      <td>
                        $
                        {editorState?.carrito
                          .map((x) => x?.importe)
                          .reduce((acc, score) => acc + score, 0)}{' '}
                        MXN
                      </td>
                    </tr>
                  </tfoot>
                </Table>

                <h1
                  style={{
                    font: 'normal normal normal 9px/11px Lato',
                    color: '#6F767D',
                  }}
                >
                  {t('templateEdition.priceIncludesTax')}
                </h1>
                <Checkbox
                  label={t('Revisión por parte de un abogado')}
                  className="mr-4"
                  style={{ font: 'normal normal bold 11px/14px Lato' }}
                  onClick={toggleIsLawyer}
                  checked={editorState?.checkoutInfo?.isLawyerNeeded}
                />
                <span
                  style={{ font: 'normal normal bold 11px/14px Lato' }}
                ></span>
                <hr />
                <Checkbox
                  label={t('Solicitar factura')}
                  className="mr-4"
                  style={{ font: 'normal normal bold 11px/14px Lato' }}
                  onClick={toggleIsInvoice}
                  checked={editorState?.checkoutInfo?.isInvoiceNeeded}
                />
                <span
                  style={{ font: 'normal normal bold 11px/14px Lato' }}
                ></span>
                {editorState?.checkoutInfo?.isInvoiceNeeded && (
                  <Row>
                    <Col sm={4}>
                      <FormGroup className="form-group mb-0">
                        <Label className="mb-1" for="inputEmail">
                          {t('forms.email')}{' '}
                          <span className="text-accent">*</span>
                        </Label>
                        <InputGroup>
                          <Input
                            type="email"
                            name="email"
                            id="inputEmail"
                            invalid={errorRQ.email}
                            innerRef={register({
                              required: t('templateEdition.enterEmail'),
                              pattern: {
                                value:
                                  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                message: t('templateEdition.validEmail'),
                              },
                            })}
                            placeholder={t('forms.email')}
                          />
                          <FormFeedback>
                            {' '}
                            {errorRQ?.email?.message}{' '}
                          </FormFeedback>
                        </InputGroup>
                      </FormGroup>
                    </Col>

                    <Col sm={4}>
                      <FormGroup className="form-group mb-0">
                        <Label className="mb-1" for="inputEmail">
                          {t('RFC')} <span className="text-accent">*</span>
                        </Label>
                        <InputGroup>
                          <Input
                            bsSize="md"
                            type="rfc"
                            name="rfc"
                            id="rfc"
                            invalid={errorRQ.rfc}
                            innerRef={register({
                              required: true,
                              maxLength: 13,
                              minLength: 12,
                            })}
                            placeholder={'RFC'}
                          />
                          <FormFeedback>
                            {' '}
                            {t('templateEdition.verifyRFC')}{' '}
                          </FormFeedback>
                        </InputGroup>
                      </FormGroup>
                    </Col>

                    <Col sm={3}>
                      <FormGroup className="form-group mb-0">
                        <Label className="mb-1" for="isMoral">
                          {t('Persona moral')}{' '}
                          <span className="text-accent">*</span>
                        </Label>
                        <InputGroup>
                          <Checkbox
                            className="mr-4"
                            name="isMoral"
                            onClick={() => setIsMoral(!isMoral)}
                            checked={isMoral}
                          />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                )}
              </div>
            )}
          </TabPane>
        </TabContent>
      </CardBody>

      {footer && isEditable && (
        <CardFooter tag={Container} className="bg-light">
          {innerCurrentTab === 3 && (
            <>
              <div className="d-flex justify-content-between">
                <span style={{ font: 'normal normal normal 11px/14px Lato' }}>
                  {t('templateEdition.editedAmount')}{' '}
                  {editorState?.carrito?.length}
                </span>
                {!can('EDIT_TEMPLATE') && (
                  <span style={{ font: 'normal normal bold 11px/14px Lato' }}>
                    {t('templateEdition.amount')}: $
                    {editorState?.carrito
                      .map((x) => x?.importe)
                      .reduce((acc, score) => acc + score, 0)}{' '}
                    MXN
                  </span>
                )}
              </div>
              <hr></hr>
            </>
          )}

          <ConfirmationModal
            isOpen={isConfirmationOpen}
            confirmText={buttonLegend}
            cancelText={t('actions.goBack')}
            //{/* actions.makeChanges */}
            onCancel={() => setIsConfirmationOpen(false)}
            onConfirm={handlePayment}
            QuestionComponent={Question}
            QuestionComponentProps={{
              question: t('actions.payElement', {
                count: editorState?.carrito?.length,
              }),
              participants: editorState.participants,
              setButtonLegend: setButtonLegend,
            }}
          />

          {innerCurrentTab === 2 && (
            <>
              {FooterComponent ? (
                <FooterComponent
                  saving={saving}
                  isSending={isSending}
                  onGoBack={onClose}
                  isEditable={isEditable}
                  onSubmit={submitInterceptor}
                />
              ) : (
                <Row>
                  <Col sm={6}>
                    <LoadingButton
                      color="default"
                      loading={saving}
                      loadingText={t('actions.saving')}
                      className="align-self-end animate-up w-100"
                      onClick={onClose}
                    >
                      {t('actions.goBack')}{' '}
                      {/*<FontAwesomeIcon icon="eye" className="ml-2" /> */}
                    </LoadingButton>
                  </Col>
                  <Col sm={6}>
                    <LoadingButton
                      color="accent-100"
                      disabled={!isEditable}
                      loading={isSending}
                      loadingText={t('actions.sending')}
                      className="align-self-end text-light animate-up w-100 mt-xs-4"
                      onClick={handleSubmit}
                    >
                      {t('actions.send')}
                    </LoadingButton>
                  </Col>
                </Row>
              )}
            </>
          )}

          {innerCurrentTab === 3 && (
            <>
              {!FooterComponent ? (
                <FooterComponent
                  saving={saving}
                  isSending={isSending}
                  onGoBack={onClose}
                  isEditable={isEditable}
                  onSubmit={handleSubmit}
                />
              ) : (
                <Row>
                  <Col sm={6}>
                    <LoadingButton
                      color="default"
                      loading={saving}
                      loadingText={t('actions.saving')}
                      className="align-self-end animate-up w-100"
                      onClick={() => setCheckout(1)}
                    >
                      {t('Atrás')}{' '}
                      {/*<FontAwesomeIcon icon="eye" className="ml-2" /> */}
                    </LoadingButton>
                  </Col>
                  <Col sm={6}>
                    {can('EDIT_TEMPLATE') &&
                      editorState.mode !== 'public-template' && (
                        <LoadingButton
                          color="accent-100"
                          disabled={editorState.mode === 'public-template'}
                          loading={isSending}
                          title={
                            editorState.mode === 'public-template' &&
                            'Solo puedes guardar plantillas que tienes'
                          }
                          loadingText={t('Guardando...')}
                          className="align-self-end text-light animate-up w-100 mt-xs-4"
                          onClick={handleSaveTemplate}
                        >
                          {t('Guardar')}
                        </LoadingButton>
                      )}
                    {(!can('EDIT_TEMPLATE') ||
                      editorState.mode === 'public-template') &&
                      isCheckout === 1 && (
                        <LoadingButton
                          color="accent-100"
                          disabled={!isEditable}
                          loading={isSending}
                          loadingText={t('actions.sending')}
                          className="align-self-end text-light animate-up w-100 mt-xs-4"
                          onClick={handleCheckout}
                        >
                          {t('actions.next')}
                        </LoadingButton>
                      )}

                    {isCheckout === 2 && (
                      <LoadingButton
                        color="accent-100"
                        disabled={!isEditable}
                        loading={isSending}
                        loadingText={t('actions.sending')}
                        className="align-self-end text-light animate-up w-100 mt-xs-4"
                        onClick={handleConfirm}
                      >
                        {t('actions.pay')}
                      </LoadingButton>
                    )}
                  </Col>
                </Row>
              )}
            </>
          )}
        </CardFooter>
      )}
    </Card>
  );
}

function getInitialValues(template) {
  if (!template.participants) return {};

  return {
    name: template.name,
    participants: template.participants.reduce((obj, participant) => {
      if (participant?._id) {
        obj[participant._id] = {
          name: '',
          last_name: '',
          email: '',
          label: '',
          phone: '',
          representative: '',
          requestAgreement: false,
          ...participant,
        };
      }

      return obj;
    }, {}),
  };
}

function getInitialTouched(template) {
  if (!template.participants) return {};

  return {
    name: false,
    participants: template.participants.reduce((obj, participant) => {
      obj[participant._id] = {
        name: false,
        last_name: false,
        email: false,
        label: false,
        phone: false,
        representative: false,
      };

      return obj;
    }, {}),
  };
}

const getParticipantsSchema = (participants) => {
  let schema = {};

  if (participants) {
    schema = participants.reduce((obj, participant) => {
      obj[participant._id] = ParticipantSchema;

      return obj;
    }, {});
  }

  return Yup.object().shape(schema);
};

function getContractSchema(contract) {
  return Yup.object().shape({
    name: Yup.string(),
    participants: getParticipantsSchema(contract.participants),
  });
}

function ContractConfigurationContainer({
  className,
  isPdf,
  isDynamic,
  tabs = true,
  currentTab = 1,
  header = true,
  footer = true,
  documentId,
  onReturn,
  onContractSent = () => {},
  FooterComponent,
}) {
  const { t } = useTranslation('common');
  const errorSentResponseId = 'error-sending-document';
  // router hooks
  const history = useHistory();
  const { templateId } = useParams();
  const id = templateId || documentId;
  const queryClient = useQueryClient();

  // Context
  const { profile } = useProfile();
  const [editorState, editorDispatch] = useEditor();
  // Memoization
  const shieldList = useMemo(() => {
    return Array.from(Array(2).keys()).map((number) => ({
      value: `shield${number + 1}`,
      label: t(`shield`, { context: 'number', number: number + 1 }),
    }));
  }, [t]);
  const [userLanguage, languageList] = useUserLanguage();
  const [initialValues, ContractSchema] = useMemo(() => {
    return [
      getInitialValues(editorState?.document),
      getContractSchema(editorState?.document),
    ];
  }, [editorState.document]);

  const { mutate: sendContractMutate } = useMutation(
    (payload) => fetcher(sendContract(payload)),
    {
      onSuccess: () => {
        editorDispatch({ type: RESET_DOCUMENT });
        // if (templateId) {
        //     templatesDispatch({ type: INCREMENT_SENT_CONTRACTS, templateId })
        // }
        queryClient.invalidateQueries('profile');

        setHasSucceed(true);
        setIsLoading(false);
        setSubmitting(false);
        if (onContractSent) {
          onContractSent();
        } else if (documentId) {
          history.push('/documents');
          toast.info(t('successMessages.documentCreated'));
        } else {
          setTimeout(() => {
            handleCancel();
          }, 1000);
        }
      },
      onError: (error) => {
        setHasSucceed(false);
        setIsLoading(false);
        history.replace(`/documents/${editorState.document._id}/edit`);
        toast.error(
          t(`errors.${error.message}`, t('errorMessages.sendingContract')),
          {
            toastId: errorSentResponseId,
          }
        );
      },
      onSettled: () => {
        setIsLoading(false);
      },
    }
  );

  const { mutate: saveContractMutate } = useMutation(
    (payload) => fetcher(saveContract(payload)),
    {
      onSuccess: (result) => {
        editorDispatch({ type: SET_DOCUMENT, document: result.data });
        sendContractMutate({
          _id: result.data._id,
        });
      },
      onError: () => {
        setIsLoading(false);
      },
    }
  );

  // State
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [accountVerified, setAccountVerified] = useAccountVerificationState({
    verified: false,
  });
  //const [accountVerified, setAccountVerified] = useAccountVerificationState();
  const [currentLanguage, setCurrentLanguage] = useState(
    userLanguage ?? languageList?.[0]
  );
  // const [isNoContractsOpen, setIsNoContractsOpen] = useState(false)
  const [hasSucceed, setHasSucceed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fillMyData, setFillMyData] = useState('');
  const { checkMissingSignatures, checkCredits, checkSignatureCredits } =
    useEditorActions();
  const [newCurrentTab, setNewCurrentTab] = useState(currentTab);
  currentTab = newCurrentTab;
  const auth = useAuthState();

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (accountVerified.verified) {
      setIsOpen(false);
      setAccountVerified({ verified: false });
      auth.openAuthModal({ type: 'login' });
    }
  }, [auth, setAccountVerified, accountVerified]);

  const onSignUpSuccess = () => {
    setIsOpen(true);
  };

  const submitInterceptor = () => {
    if (!auth.hasAccount) {
      auth.openAuthModal({ type: 'signup', onSignUpSuccess });
      setIsLoading(false);
    } else formik.handleSubmit();
  };

  const formik = useFormik({
    initialValues,
    onSubmit: (values, actions) => {
      let hasRequestAgreement = false;

      if (editorState.shieldType.value === 'shield3') {
        const participants = Object.values(values.participants);
        hasRequestAgreement = participants?.some?.((p) => p.requestAgreement);

        if (!hasRequestAgreement) {
          return toast.error(t('errors.MissingRequestAgreement'), {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      }

      const hasNoCredits = checkCredits();
      const hasNoSignatureCredits = checkSignatureCredits();
      const isMissingSignatures = checkMissingSignatures();

      if (isMissingSignatures || hasNoCredits || hasNoSignatureCredits)
        return actions.setSubmitting(false);

      setHasSucceed(false);
      setIsConfirmationOpen(true);
    },
    validationSchema: ContractSchema,
    enableReinitialize: true,
  });

  useEffect(() => {
    editorDispatch({ type: SET_SHIELD_TYPE, shieldType: shieldList[0] });
  }, [shieldList, editorDispatch]);

  useEffect(() => {
    editorDispatch({
      type: SET_LANGUAGE,
      language: userLanguage ?? languageList?.[0],
    });
  }, [languageList, userLanguage, editorDispatch]);

  // useEffect(() => {

  //     if (modalsState.reset) {
  //         setFillMyData('')
  //         formik.setValues(getInitialValues(editorState.document));
  //         formik.setTouched(getInitialTouched(editorState.document));
  //         dispatch({ type: UNRESET })
  //     }
  // }, [formik, dispatch, modalsState.reset, editorState.document])

  const handleFillMyData =
    ({ name, checked }) =>
    () => {
      if (!checked) {
        editorDispatch({ type: FILL_MY_DATA, profile, name });
      } else {
        editorDispatch({ type: RESET_FILL_MY_DATA });
      }
    };

  const handleSendContract = async (values) => {
    const hasShield2Credits =
      profile?.nom151?.remaining > 0 &&
      editorState.shieldType.value === 'shield2';
    const hasShield3Credits =
      profile?.shield3?.remaining > 0 &&
      editorState.shieldType.value === 'shield3';
    const stampNom = hasShield2Credits || hasShield3Credits;

    const newContract = {
      ...editorState.document,
      participants: Object.values(formik.values.participants).map(
        (participant) => ({
          ...participant,
          phone: unmaskPhone(participant.phone),
          last_name:
            participant.obligation === 'individual'
              ? participant.last_name
              : undefined,
          signatures: editorState.isPdf
            ? editorState.signatures[participant._id]
            : [],
        })
      ),
      language: editorState.language.value?.toUpperCase?.(),
      stampNom,
      templateId,
      shield3ValidationRequired: true,
      shield: editorState.shieldType.value,
    };
    setIsLoading(true);
    // alert(JSON.stringify(values, null, 2));
    // await db.table('contracts').put({ id: modalsState.templateId, ...newContract })

    // guardamos contrato
    saveContractMutate(newContract);
  };

  useEffect(() => {
    editorDispatch({
      type: SET_PARTICIPANTS,
      participants: Object.values(formik.values?.participants ?? {}),
    });
  }, [formik.values, editorDispatch]);

  // console.log({modalsState});
  const setSubmitting = useCallback(formik.setSubmitting, [
    formik.setSubmitting,
  ]);

  const handleCancel = useCallback(() => {
    setIsConfirmationOpen(false);
    setHasSucceed(false);
    setSubmitting(false);
    setNewCurrentTab(3);
  }, [setSubmitting]);

  const handleClose = useCallback(() => {
    // history.push('/')
    history.goBack();
  }, [history]);

  useEffect(() => {
    if (profile?.nom151?.remaining > 0) {
      editorDispatch({
        type: SET_SHIELD_TYPE,
        shieldType: shieldList.find((shield) => shield.value === 'shield2'),
      });
    }
  }, [profile, shieldList, editorDispatch]);

  function handleLanguageChange(option) {
    editorDispatch({ type: SET_LANGUAGE, language: option });
  }

  function handleShieldChange(option) {
    editorDispatch({ type: SET_SHIELD_TYPE, shieldType: option });
  }

  const handleRequestAgreement = (fieldName, checked) => () => {
    formik.setFieldValue(fieldName, !checked);
  };

  const handleDocumentLoadSuccess = ({ numPages }) => {
    editorDispatch({ type: SET_NUM_PAGES, numPages });
  };

  const handlePDFPageClick = ({ pageNumber }) => {
    editorDispatch({ type: SET_CURRENT_PAGE, pageNumber });
  };

  const goToPage = (pageNumber) => () => {
    editorDispatch({ type: SET_CURRENT_PAGE, pageNumber });
  };

  const handleAddParticipant = () => {
    editorDispatch({ type: 'add-participant' });
  };

  const handleRemoveParticipant = (participantId) => () => {
    editorDispatch({ type: 'remove-participant', participantId });
  };

  const handleAddParticipantSignature = (participantId) => () => {
    editorDispatch({ type: 'add-signature', participantId });
  };

  return (
    <React.Fragment key={id}>
      <ContractConfiguration
        templateId={documentId}
        className={className}
        saving={false}
        formik={formik}
        tabs={tabs}
        header={header}
        footer={footer}
        FooterComponent={FooterComponent}
        currentTab={currentTab}
        onClose={onReturn ?? handleClose}
        onFillMyData={handleFillMyData}
        fillMyData={editorState.fillMyData}
        disableStampNom={profile.nom151 && profile.nom151.remaining <= 0}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onLanguageChange={handleLanguageChange}
        currentLanguage={editorState.language}
        currentJurisdiction={editorState.jurisdiction}
        currentSignatureType={editorState.signatureType}
        languages={languageList}
        shields={shieldList}
        shieldType={editorState.shieldType}
        onShieldChange={handleShieldChange}
        isPdf={editorState.isPdf}
        isDynamic={editorState.isDynamic}
        isEditable={true}
        onRequestAgreement={handleRequestAgreement}
        numPagesArr={editorState.numPagesArr ?? []}
        pdfUrl={editorState.document?.importedPdf}
        onPDFPageClick={handlePDFPageClick}
        goToPage={goToPage}
        onDocumentLoadSuccess={handleDocumentLoadSuccess}
        onAddParticipant={handleAddParticipant}
        onRemoveParticipant={handleRemoveParticipant}
        onAddParticipantSignature={handleAddParticipantSignature}
        submitInterceptor={submitInterceptor}
      />
      <ConfirmationModal
        isOpen={isConfirmationOpen}
        hasSucceed={hasSucceed}
        isLoading={isLoading}
        onConfirm={handleSendContract}
        confirmText={t('actions.send')}
        cancelText={t('Personalizar elementos')}
        question={t('sendDocumentQuestion')}
        onCancel={handleCancel}
        participants={editorState.participants}
      />

      <AccountVerifyModal isOpen={isOpen} />
    </React.Fragment>
  );
}

export default ContractConfigurationContainer;
